import {is} from "typia";

type CancellationMessage = 'USER_CANCELLED' | 'Share canceled';

type UserCancelledError =
  | CancellationMessage
  | {readonly message: CancellationMessage}
  | {readonly errorMessage: CancellationMessage}
  | {readonly error: CancellationMessage};

/** A native flow (sign-in, purchase, share sheet) the user backed out of. Not an error at all. */
export function isUserCancelled(error: unknown): boolean {
  return is<UserCancelledError>(error);
}

/** Known noise: logged to the console, but never toasted or sent to Amplitude. Sentry still gets it. */
export function shouldNotShowError(error: unknown): boolean {
  return error instanceof Error && (
    error.name === 'AbortError' ||
    error.name.includes('History API') ||
    error.message.includes('History API') ||
    error.message.includes('Importing a module script failed') ||
    error.message.includes('Database deleted by request of the user') ||
    error.message.includes('During hydration Angular') ||
    error.message.includes('s.replaceAll is not a function')
  );
}
